// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","container":"_8BwJfV29AWVt","sadChiku":"wK-2On7+rb03","button":"BX6lM9J8fpTI"};